import apiHeader from "@/helpers/apiHeader";

const userFormService = {
  create(formData) {
    return apiHeader.post("request-pool/user-form", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  createFromCataloguerForm(params) {
    return apiHeader.post("request-pool/user-form/create-from-cataloguer", params, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  updateFromCataloguerForm(id, params) {
    return apiHeader.post(`request-pool/user-form/update-from-cataloguer/${id}`, params, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  update(id, formData) {
    return apiHeader.post(`request-pool/user-form/update/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  importEmcr(idEmcr, file) {
    const fd = new FormData();
    fd.append("file", file);
    return apiHeader.post(`request-pool/user-form/import/${idEmcr}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  delete(id) {
    return apiHeader.delete(`request-pool/user-form/${id}`);
  },
  checkDuplSpnInUserForm(mcrCode) {
    return apiHeader.get(`request-pool/user-form/check-duplicate-mcr/${mcrCode}`);
  }
};

export default userFormService;
